import { cardSrc } from './resultParsers';

const LINE_GROUPS = [[1, 2, 3], [4, 5, 6], [8, 9, 10], [11, 12, 13]];

function rankOf(code) {
  return String(code).slice(0, -2).toUpperCase();
}
function rankVal(r) {
  if (r === 'A') return 1;
  if (r === 'J') return 11;
  if (r === 'Q') return 12;
  if (r === 'K') return 13;
  return parseInt(r, 10) || 0;
}

export default function Lucky7Result({ detail }) {
  const card = detail?.card || '';
  const valid = card && card !== '1';

  const rank = valid ? rankOf(card) : '';
  const val = valid ? rankVal(rank) : 0;
  const suit = valid ? String(card).slice(-2).toUpperCase() : '';

  // desc rdesc se seedhe: "<Winner>#<Odd/Even>#<Color>#<Card>#<Line>" (e.g.
  // "Tie#Odd#Red#7#"); rdesc na ho to card se derive. NOTE: 7 = Tie (Lucky 7 nahi).
  const rparts = String(detail?.rdesc || '').split('#');
  const winner = rparts[0] || (!valid ? '' : val < 7 ? 'Low Card' : val > 7 ? 'High Card' : 'Tie');
  const oddEven = rparts[1] || (!valid ? '' : val % 2 === 1 ? 'Odd' : 'Even');
  const color = rparts[2] || (!valid ? '' : (suit === 'SS' || suit === 'CC') ? 'Black' : 'Red');
  const cardLabel = rparts[3] || rank;
  const line = rparts.length > 4 ? rparts[4] : (valid ? (LINE_GROUPS.find((g) => g.includes(val))?.join(' ') || '') : '');

  return (
    <div className="row row5 align-items-center">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center" style={{ alignItems: 'flex-end' }}>
            <div className="casino-result-cards">
              {valid && (
                <div className="casino-result-cards-item">
                  <img src={cardSrc(card)} alt={card} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winner}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Odd/Even</div>
            <div>{oddEven}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Color</div>
            <div>{color}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Card</div>
            <div>{cardLabel}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Line</div>
            <div>{line}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
